export const testFlag = window.location.host.includes("test") || window.location.host.includes("localhost");
export const BaseUrl = testFlag
  ? "https://test-play.sallochat.com" // https://test-play.tianxicp.com
  : // 'https://test2-play.sallochat.com' //  test2环境
    "https://play.sallochat.com"; //pro
export const ImgBaseUrl = testFlag ? "https://test-img.sallochat.com" : "https://img.sallochat.com"; //pro
export const WebUrl = testFlag ? "https://test-www.sallochat.com" : "https://www.sallochat.com"; //pro
export const thirdPayUrl = testFlag ? "https://test-xpay.sallochat.com" : "https://xpay.sallochat.com"; //pro
export const OSS_URL = "https://xp-usa-online.s3.amazonaws.com";
export const SignatureKey = testFlag ? "W5Y2qfRCXJw6MXP7" : "W1bctaVidKfpcxbQ"; //pro
export const DecodeKey = testFlag ? "SVZeNfzZN3EQcUtQ" : "IImtpZCI6IUwM2E1"; //pro
export const ZegoAppId = testFlag ? 673933163 : 834597803; //pro
export const ReportSDK = testFlag
  ? "//webtracksdk-test.stnts.com/websdkv2.4.test.js"
  : "//dtsdk.xposeai.cc/websdkv2.4.js"; //pro
export const ReportDes = testFlag ? void 0 : "//dssp.xposeai.cc"; //pro
export const IMConfig = {
  appkey: testFlag ? "4c8b36a496a79f5d19e9ffeeb89e4ec7" : "7f0f8b104b54639d756aaa041359497c", //pro
  debugLevel: "warn",
  apiVersion: "v2",
};
export const GoogleAuthClientId = "671980133687-s4a5icivmrk6u3ug3s9khq9uvghcemv7.apps.googleusercontent.com";
export const DecodePrefix = "DAIDAI-";
export const RequestBaseSignature = {
  source: 6, //h5
  vnum: "1",
  companyCode: "SC_302",
  appCode: "SC_302",
};
export const RequestHeaderExts = {
  appSubCode: "SALLO",
  version: "1.0.0",
};
export const NSFWBlackList = ["99999"];

export const DefaultChannel = "PIDUDicBjEaa";
export const ChannelCacheKey = "_scck";
export const AuthCacheKey = "_sack";
export const AuthIdCacheKey = "_saick";
export const UCUidCacheKey = "_suuck";
export const LangCacheKey = "_slck";
export const NSFWCacheKey = "_snck";
export const ProductId = 320007;

export const BingKeyWord = "_bing_keyword";
export const BingMsclkid = "_bing_msclkid";
export const BingMsclkidCreationTime = "_bing_msclkid_creationTime";
export const BingQuery = "_bing_query";

export const GoogleGclid = "_gclid";
export const GoogleGclidCreationTime = "_gclid_creationTime";
export const GoogleKeyword = "_ggkeyword";
export const GoogleMatchType = "_ggmatchtype";

export const UuidKey = "_uuid";
// 18+弹窗协议
export const ADULT_AGREE = "_adult_agree";
export const FIRST_UPLOAD_IMAGE = "_first_upload_image";
export const LAST_FACE_IMAGE = "_last_face_image";
export const LAST_TARGET_IMAGE = "_last_target_image";
export const FIRST_SEX_UPLOAD_IMAGE = "_first_sex_upload_image";
export const TEXT_TO_IMAGE_INPUT = "_text_to_image_input";
export const FACE_AUTH_URL = "_face_auth_url";
export const ReferenceUrl = testFlag ? "https://test-m.sallochat.com" : "https://m.sallochat.com"; //pro
